import React from 'react'

const formatNumber = (n) =>
  (n === null || n === undefined) ? '—' : n.toLocaleString('id-ID')

const Badge = ({ delta }) => {
  if (delta === null || delta === undefined) return null
  if (delta === 0) {
    return <div className='dbv2-kpi-badge dbv2-flat'>— sama dengan tahun lalu</div>
  }
  const up = delta > 0
  return (
    <div className={`dbv2-kpi-badge ${up ? 'dbv2-up' : 'dbv2-down'}`}>
      {up ? '▲' : '▼'} {formatNumber(Math.abs(delta))} vs tahun lalu
    </div>
  )
}

/**
 * US-DB-2 — Sertifikat Aktif & Customer Aktif. Always as of today, badge is
 * a fixed year-over-year comparison (AC-3/AC-4). No filter.
 */
export default function KpiCards ({ summary, loading }) {
  if (loading && !summary) {
    return <div className='dbv2-loading'>Memuat ringkasan…</div>
  }
  if (!summary) return null

  const certs = summary.activeCertificates || {}
  const customers = summary.activeCustomers || {}

  return (
    <div className='dbv2-kpi-grid'>
      <div className='dbv2-kpi-card'>
        <div className='dbv2-kpi-top'>
          <div className='dbv2-kpi-icon dbv2-green'>⚑</div>
          <div className='dbv2-kpi-label'>Sertifikat Aktif</div>
        </div>
        <div className='dbv2-kpi-value'>{formatNumber(certs.total)}</div>
        <Badge delta={certs.deltaYoY} />
      </div>

      <div className='dbv2-kpi-card'>
        <div className='dbv2-kpi-top'>
          <div className='dbv2-kpi-icon dbv2-blue'>★</div>
          <div className='dbv2-kpi-label'>Customer Aktif</div>
        </div>
        <div className='dbv2-kpi-value'>{formatNumber(customers.total)}</div>
        <Badge delta={customers.deltaYoY} />
      </div>
    </div>
  )
}
